/* 固定購入バー(2026-08-20)
   参考: afuribrewing.com の商品ページ下部のバー。

   - チップを押したら本体の本数選択(ラジオ)をクリックする。価格・在庫・
     カートへの反映はDawn標準の処理に任せ、こちらは表示を合わせるだけ
   - 本体側で本数が変わったときもバーの選択状態を追従させる
     (Dawnはバリアント変更で商品情報のDOMを差し替えるため、
      イベントはdocumentへ委譲して張り替えに耐えるようにする)
   - カート追加はボタンのform属性が担うのでJSは関与しない */

if (!customElements.get('ny-soda-buy-bar')) {
  class NySodaBuyBar extends HTMLElement {
    connectedCallback() {
      this.options = Array.from(this.querySelectorAll('.ny-soda-buy-bar__option'));
      this.priceEl = this.querySelector('[data-buy-bar-price]');
      this.nameEl = this.querySelector('[data-buy-bar-name]');
      this.infoSelector = `#ProductInfo-${this.dataset.section}`;

      this.options.forEach((button) => {
        button.addEventListener('click', () => this.select(button));
      });

      this.onDocumentChange = (event) => {
        const target = event.target;
        if (!target || typeof target.matches !== 'function') return;
        if (target.matches(`${this.infoSelector} input[type="radio"]`)) {
          this.reflect(target.value);
        }
      };
      document.addEventListener('change', this.onDocumentChange);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onDocumentChange);
      this.releaseHold?.();
    }

    radioFor(value) {
      const info = document.querySelector(this.infoSelector);
      if (!info) return null;
      return Array.from(info.querySelectorAll('input[type="radio"]')).find((input) => input.value === value);
    }

    select(button) {
      const radio = this.radioFor(button.dataset.optionValue);
      // 本体のラジオを押してDawnの更新処理を通す(価格・フォーム・画像が揃う)
      if (radio && !radio.checked) {
        this.holdScroll(button);
        radio.click();
      }
      this.mark(button);
    }

    /* バーで本数を選んだときはページを動かさない(2026-10-16 ユーザー指示)。
       Dawnはバリアント更新の直後に、(1)本体の本数ボタンへフォーカスを戻し、
       (2)そのバリアントの画像までページを戻す(media-gallery.js の setActiveMedia)。
       そのためページ上部の本数選択まで飛んでいた。更新完了の通知(variantChange)を
       受けた時点の位置を覚え、直後に起きるスクロールを打ち消して元の位置に留める。
       フォーカスはバーのボタンへ戻す。 */
    holdScroll(button) {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.releaseHold?.();
      let onScroll = null;
      let timer = null;
      const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
        const top = window.scrollY;
        onScroll = () => {
          if (Math.abs(window.scrollY - top) > 1) window.scrollTo({ top, behavior: 'instant' });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        timer = setTimeout(() => {
          onScroll();
          if (button.isConnected) button.focus({ preventScroll: true });
          this.releaseHold();
        }, 400);
      });
      // 通信に失敗して通知が来ない場合も、張りっぱなしにしない
      const fallback = setTimeout(() => this.releaseHold(), 5000);
      this.releaseHold = () => {
        unsubscribe();
        if (onScroll) window.removeEventListener('scroll', onScroll);
        clearTimeout(timer);
        clearTimeout(fallback);
        this.releaseHold = null;
      };
    }

    reflect(value) {
      const button = this.options.find((option) => option.dataset.optionValue === value);
      if (button) this.mark(button);
    }

    mark(button) {
      this.options.forEach((option) => {
        const selected = option === button;
        option.classList.toggle('is-selected', selected);
        option.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (this.priceEl && button.dataset.price) this.priceEl.textContent = button.dataset.price;
      if (this.nameEl && button.dataset.variantName) this.nameEl.textContent = button.dataset.variantName;
    }
  }

  customElements.define('ny-soda-buy-bar', NySodaBuyBar);
}
